import api from './api'

export default {
  // Config global de anti-captura. Retorna sempre { blur_ficha, blur_modal_ph3a }.
  get: async () => {
    const response = await api
      .get('/api/find-visualization-config')
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  },
  update: async (data) => {
    const response = await api
      .post('/api/update-visualization-config', data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ ...response }) => response)
      .catch(({ ...response }) => response)

    return response
  }
}
